import './Footer.css'
import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { GpLogo } from '../components/gp'
import TermsModal from '../navigationComponents/signUp/TermsModal'
import { PUBLIC_URL } from '../constants'

const AUTH_ROUTES = ['/sign-in', '/sign-up', '/forgot-password']

const linkStyle = {
    font: 'var(--gp-caption)',
    color: '#E8EAE5',
    textDecoration: 'none',
    opacity: 0.7,
}

function FooterCol({ title, links }) {
    return (
        <div>
            <div
                style={{
                    font: 'var(--gp-body-med)',
                    color: '#FBFBF9',
                    marginBottom: 14,
                }}
            >
                {title}
            </div>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {links.map((l) => (
                    <li key={l.label}>
                        <a
                            href={l.href}
                            style={linkStyle}
                            {...(l.external
                                ? { target: '_blank', rel: 'noopener noreferrer' }
                                : {})}
                        >
                            {l.label}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    )
}

const Footer = () => {
    const { pathname } = useLocation()
    const [legalDoc, setLegalDoc] = useState(null) // 'privacy' | 'terms' | null
    const [termsLoading, setTermsLoading] = useState(true)
    const [termsText, setTermsText] = useState(undefined)
    const [privacyText, setPrivacyText] = useState(undefined)

    useEffect(() => {
        const legalDocumentsUrl = `${PUBLIC_URL}legal/en/documents?audience=CONSUMER`
        fetch(legalDocumentsUrl, { method: 'GET' })
            .then((r) => r.json())
            .then((result) => {
                if (result) {
                    fetch(result.privacyUrl).then((r) => r.text()).then(setPrivacyText)
                    fetch(result.termsOfServiceUrl).then((r) => r.text()).then(setTermsText)
                    setTermsLoading(false)
                }
            })
            .catch(() => setTermsLoading(false))
    }, [])

    // Auth screens take over the full viewport — hide the footer.
    if (AUTH_ROUTES.some((p) => pathname === p || pathname.startsWith(p + '/'))) {
        return null
    }
    return (
        <footer
            style={{
                marginTop: 'auto',
                background: 'var(--gp-ink)',
                color: '#E8EAE5',
                padding: '48px 40px 28px',
            }}
        >
            <div
                style={{
                    maxWidth: 1280,
                    margin: '0 auto',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: 32,
                }}
            >
                <div>
                    <GpLogo size={20} variant="light" />
                    <a
                        href="https://www.linkedin.com/company/gopowerev/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        style={{
                            marginTop: 18,
                            width: 36,
                            height: 36,
                            borderRadius: '50%',
                            background: 'rgba(255,255,255,0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            color: '#E8EAE5',
                        }}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5S0 4.881 0 3.5C0 2.12 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.24 8h4.52v14H.24V8zM7.5 8h4.33v1.92h.06c.6-1.14 2.07-2.35 4.27-2.35 4.57 0 5.41 3.01 5.41 6.92V22h-4.51v-6.64c0-1.58-.03-3.62-2.2-3.62-2.2 0-2.54 1.72-2.54 3.5V22H7.5V8z" />
                        </svg>
                    </a>
                    <div
                        style={{
                            marginTop: 28,
                            font: 'var(--gp-caption)',
                        }}
                    >
                        <span style={{ opacity: 0.55 }}>Copyright 2010 – 2026</span>
                        &nbsp; · &nbsp;
                        <span
                            onClick={() => setLegalDoc('privacy')}
                            style={{ ...linkStyle, cursor: 'pointer' }}
                        >
                            Privacy Policy
                        </span>
                        &nbsp; · &nbsp;
                        <span
                            onClick={() => setLegalDoc('terms')}
                            style={{ ...linkStyle, cursor: 'pointer' }}
                        >
                            Website Terms
                        </span>
                    </div>
                </div>

                <FooterCol
                    title="Company"
                    links={[
                        {
                            label: 'About Us',
                            href: 'https://gopowerev.com/about',
                            external: true,
                        },
                        {
                            label: 'Contact Us',
                            href: 'https://gopowerev.com/contactus',
                            external: true,
                        },
                    ]}
                />
            </div>

            <TermsModal
                open={legalDoc !== null}
                handleClose={() => setLegalDoc(null)}
                setTermsAccepted={() => {}}
                title={legalDoc === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions'}
                termsText={legalDoc === 'terms' ? termsText : undefined}
                privacyText={legalDoc === 'privacy' ? privacyText : undefined}
                loading={termsLoading}
            />
        </footer>
    )
}
export default Footer
